import React from "react";
import itunesBadge from "../../images/email/itunes-badge.webp";
import googlePlayBadge from "../../images/email/google-play-badge.webp";

const MobileNotAvailableModal = ({ visible, onClose }) => {
  const onFastPress = (handler) => (event) => {
    if (event.type === "click" && event.detail > 0) return;
    handler();
  };

  const stopEvent = (event) => {
    event.stopPropagation();
  };

  // Always render — conditional mount/unmount causes iOS to lose the next tap's
  // hit area after the element disappears (same issue as the sidebar overlay).
  // Toggle via CSS pointer-events + opacity instead.
  return (
    <div
      className={`mobile-not-available-overlay ${visible ? "active" : ""}`}
      onPointerUp={onFastPress(onClose)}
      onClick={onFastPress(onClose)}
    >
      <div
        className="mobile-not-available-box"
        onPointerUp={stopEvent}
        onClick={stopEvent}
      >
        <button
          type="button"
          className="mobile-not-available-close"
          onPointerUp={onFastPress(onClose)}
          onClick={onFastPress(onClose)}
        >✕</button>
        <div className="mobile-not-available-content">
          <h1>Please download the NYA App</h1>
          <div className="mobile-not-available-badges">
            <a
              href="https://apps.apple.com/us/app/neil-young-archives/id1444818920"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={itunesBadge} alt="Get it on iTunes" />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.shakey.nyarchives"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={googlePlayBadge} alt="Get it on Google Play" />
            </a>
          </div>
          <h2>or visit us from your desktop computer</h2>
        </div>
      </div>
    </div>
  );
};

export default MobileNotAvailableModal;
